export const CLIENT_DEMAND_TYPE = Object.freeze({
  SELLING: 'SELLING',
  BUYING: 'BUYING'
})

export const CLIENT_DEMAND_REASON = Object.freeze({
  RECEIVING_SERVICES: 'RECEIVING_SERVICES',
  RECEIVING_INVESTMENT: 'RECEIVING_INVESTMENT',
  DONATIONS: 'DONATIONS',
  RECEIVING_OTHER: 'RECEIVING_OTHER',
  SENDING_FAMILY: 'SENDING_FAMILY',
  SERVICES_PURCHASE: 'SERVICES_PURCHASE',
  INVESTMENT: 'INVESTMENT',
  SENDING_OTHER: 'SENDING_OTHER'
})
